/*!
 * @copyright
 * Copyright(c) 2018 SICK AG
 */
import * as tslib_1 from "tslib";
import { CrownShape } from './CrownShape';
import { Shape } from './CrownShapeCap';
import { Solids } from '@sick-davinci/glow';
import { DoubleSide } from 'three';
let ShapeEllipse = class ShapeEllipse extends CrownShape {
    constructor(shape, decoration, material) {
        super(shape, decoration);
        const geometry = Solids.createCircle(1.0);
        geometry.scale(shape.radiusX, shape.radiusY, 1);
        geometry.translate(shape.cx, shape.cy, 0);
        geometry.rotateZ(shape.orientationRad);
        this.geometry = geometry;
        this.material = CrownShape.getFillMaterial(material, decoration, { side: DoubleSide, depthWrite: false });
        this.addOutline(geometry, decoration);
    }
    format() {
        /*
        const {source, t, r, s} = this.transformPose<ShapeEllipseDesc>();
    
        return {
          radiusX: s.x * source.radiusX,
          radiusY: s.y * source.radiusY,
          orientationRad: r.x,
          cx: source.cx + t.x,
          cy: source.cy + t.y,
        };
        */
        return undefined;
    }
};
ShapeEllipse = tslib_1.__decorate([
    Shape('Shape.Ellipse'),
    tslib_1.__metadata("design:paramtypes", [Object, Object, Object])
], ShapeEllipse);
export { ShapeEllipse };
//# sourceMappingURL=ShapeEllipse.js.map